import { AllCurrencies, HistoryStatus } from "@lib/types/Billing";
import { Customer } from "@lib/types/Customer";
import { CustomerLead } from "@lib/types/CustomerLead";

export enum SendByteWalletAddressCreationType {
  SINGLE = "single",
  MULTIPLE = "multiple",
}

export enum SendByteWalletType {
  HOT = "hot",
  COLD = "cold",
  // HARDWARE = "hardware",
  // PAPER = "paper",
  // MULTISIG = "multisig",
  // CUSTODIAL = "custodial",
}

export enum SendByteWalletUsage {
  WhiteLabel = "WhiteLabel",
  Lead = "Lead",
}

export type SendByteWallet = {
  id: string;
  name: string;
  type: SendByteWalletType;
  usage?: SendByteWalletUsage;
  lastCustomId: number | null;
  customerId: string | null;
  customer?: Customer;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};

export enum SendByteWalletAddressType {
  BTC = "BTC",
  ETH = "ETH",
  USDT = "USDT",
}

export enum SendByteWalletAddressProtocol {
  Native = "Native",
  ERC20 = "ERC20",
  TRC20 = "TRC20",
  BEP20 = "BEP20",
}

export enum SendByteWalletAddressStatus {
  Available = "Available",
  InUse = "InUse",
  Reserved = "Reserved",
  Disabled = "Disabled",
}

export type SendByteWalletAddress = {
  id: string;
  customId: number;
  address: string;
  network: SendByteWalletAddressType;
  protocol: SendByteWalletAddressProtocol;
  status: SendByteWalletAddressStatus;
  walletId: string;
  wallet?: SendByteWallet;
  customerId: string | null;
  customer?: Customer;
  balance: string;
  lastScanDate: string | null;
  disabled: boolean;
  remainingBalance: string;
  customerUserId: string | null;
  customerUser?: CustomerLead;

  extraData: null | {
    viewUrl?: string;
  };

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};

export type SendBytePaymentRequest = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  sendByteWalletAddressId: string | null;
  sendByteWalletAddress?: SendByteWalletAddress;

  customerId: string | null;
  customer?: Customer;

  status: HistoryStatus;
  amount: number;
  network: SendByteWalletAddressType;
  error: string | null;

  extraData: null | {
    address?: string;
    addressLastScan?: string;
    scanned?: {
      lastTxAmount?: number;
      total?: number;
    };
  };

  customerUserId: string | null;
  customerUser?: CustomerLead;
  baseTpNumber: number | null;
};

export type SendByteScannedTransaction = {
  id: string;

  sendByteWalletAddressId: string;
  sendByteWalletAddress?: SendByteWalletAddress;

  customerUserId: string | null;
  customerUser?: CustomerLead;

  customerId: string | null;
  customer?: Customer;

  txId: string;
  amount: string;
  confirmed: string;
  confirmedDate: string;
  fromWalletAddress: string;
  tokenType: string;

  contractType: string;
  convertedAmount: string | null;
  convertedRate: string | null;
  convertedTo: AllCurrencies | null;

  extraData?: {
    transactionDetailUrl?: string;
    transaction_id?: string;
  };

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};
